<main class="app-shell" [class.dark-theme]="isDarkMode()">
  <header class="top-bar">
    <div class="top-bar__inner">
      <div class="brand">
        <img class="brand__logo" src="chevron-logo.png" alt="Chevron logo" />
        <a class="brand__title" routerLink="/" aria-label="Chevron AI Plugins home">
          Chevron AI Plugins
        </a>
      </div>

      <div class="top-bar__actions">
        <div class="theme-toggle" role="group" aria-label="Theme selector">
          <button
            class="theme-toggle__button"
            type="button"
            (click)="toggleTheme()"
            [attr.aria-pressed]="isDarkMode()"
          >
            <span class="theme-toggle__icon" aria-hidden="true">
              <i
                class="fa-solid"
                [class.fa-moon]="!isDarkMode()"
                [class.fa-sun]="isDarkMode()"
              ></i>
            </span>
            <span class="theme-toggle__label">{{ isDarkMode() ? 'Day' : 'Dark' }}</span>
            <span class="theme-toggle__switch" aria-hidden="true">
              <span
                class="theme-toggle__thumb"
                [class.theme-toggle__thumb--on]="isDarkMode()"
              ></span>
            </span>
          </button>
        </div>

        @if (auth.isAuthenticated()) {
          <div class="user-menu">
            <button
              class="user-menu__trigger"
              type="button"
              (click)="toggleUserMenu()"
              [attr.aria-expanded]="showUserMenu()"
            >
              <span class="user-name">{{ auth.currentUser()?.name }}</span>
              <i
                class="fa-solid fa-chevron-down user-menu__caret"
                [class.user-menu__caret--open]="showUserMenu()"
                aria-hidden="true"
              ></i>
            </button>

            @if (showUserMenu()) {
              <div class="user-menu__dropdown">
                <button class="user-menu__item" type="button" (click)="logout()">
                  <i class="fa-solid fa-arrow-right-from-bracket" aria-hidden="true"></i>
                  Logout
                </button>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </header>

  <div class="page-content">
    @if (auth.error()) {
      <div class="auth-error" role="alert">
        {{ auth.error() }}
        <button type="button" (click)="auth.login()">Try again</button>
      </div>
    }

    <router-outlet></router-outlet>
  </div>

  @if (showBackToTop()) {
    <button
      class="back-to-top"
      type="button"
      (click)="scrollToTop()"
      aria-label="Back to top"
    >
      <i class="fa-solid fa-chevron-up" aria-hidden="true"></i>
    </button>
  }
</main>
